import React from 'react';
import { Menu, Button, Space } from 'antd';
import { Link } from 'react-router-dom';

// This is a placeholder for your existing Navbar code
const Navbar = () => {
  return (
    <div>
      {/* Existing Navbar content */}
      <Menu mode="horizontal" style={{ background: '#fff', borderBottom: '1px solid #e5e7eb' }}>
        <Menu.Item key="home">
          <Link to="/">Home</Link>
        </Menu.Item>
        <Menu.Item key="profile">
          <Link to="/profile">Profile</Link>
        </Menu.Item>
        <Menu.Item key="privacy">
          <Link to="/DataPrivacy">Privacy and Data Sharing</Link>
        </Menu.Item>
        <Menu.Item key="contact">
          <Link to="/ContactForm">Contact</Link>
        </Menu.Item>
      </Menu>

      {/* Nada Widget */}
      <div id="nada-widget-iframe-container">
        <iframe
          id="nada-widget-iframe"
          width="340px"
          title="Nada Chat Widget"
          nada-bg-color="rgba(214.38888888888889, 221.94444444444446, 229.5)"
          nada-handle="ACHRAI"
          style={{ position: 'fixed', bottom: '0px', right: '0px' }}
          frameBorder="0"
        ></iframe>
        <iframe
          id="nada-widget-chat-iframe"
          frameBorder="0"
        ></iframe>
        <script src="https://donada.com/assets/static-js/nada-widget.js"></script>
      </div>
    </div>
  );
};

export default Navbar;